import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Tag Multiple"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-tag-multiple',
    templateUrl: './icon-tag-multiple.component.html',
    styleUrls: ['./icon-tag-multiple.component.scss'],
    standalone: false
})
export class IconTagMultipleComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
